import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotTopicsGrid from './components/HotTopicsGrid';
import CategorySection from './components/CategorySection';
import CommentsSection from './components/CommentsSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吃瓜51网',
    url: 'https://chigua51.com',
    description: '吃瓜51网(Chigua51.com)提供全网最新娱乐八卦资讯，聚焦51个热门话题，每日更新网红翻车现场与独家爆料。吃瓜51网，吃瓜第一线。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://chigua51.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜51网',
    url: 'https://chigua51.com',
    description: '吃瓜51网(Chigua51.com)提供全网最新娱乐八卦资讯，聚焦51个热门话题，每日更新网红翻车现场与独家爆料。',
    email: 'business@chigua51.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '光华路SOHO 2期B座12层',
    },
  };

  const webpageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '吃瓜51网 - 最新娱乐八卦 | 网红翻车现场 | 独家爆料每日更新',
    description: '吃瓜51网(Chigua51.com)提供全网最新娱乐八卦资讯，聚焦51个热门话题，每日更新网红翻车现场与独家爆料，满足八卦爱好者对最新娱乐圈动态和社会热点的一站式搜索需求。',
    url: 'https://chigua51.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜51网',
      url: 'https://chigua51.com',
    },
    about: {
      '@type': 'Organization',
      name: '吃瓜51网',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotTopicsGrid />
        <CategorySection />
        <CommentsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}